module.exports = "https://www.gc-qa.gnp.com.mx/ca148608a04aecae557616b273000f9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/registro/5.png
// module id = 1054
// module chunks = 0 1